import { render, staticRenderFns } from "./RepeatableTemplateView.vue?vue&type=template&id=8c4636b0&scoped=true"
import script from "./RepeatableTemplateView.vue?vue&type=script&lang=js"
export * from "./RepeatableTemplateView.vue?vue&type=script&lang=js"
import style0 from "./RepeatableTemplateView.vue?vue&type=style&index=0&id=8c4636b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4636b0",
  null
  
)

export default component.exports